import script from "./InternetWaitTimeLoader.vue?vue&type=script&lang=js"
export * from "./InternetWaitTimeLoader.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__